import React, { useEffect } from 'react';
import NSInput from 'bricks/NSInput/NSInput';
import NSSwitch from 'bricks/NSSwitch/NSSwitch';
import NSSelect from 'bricks/NSSelect/NSSelect';
import { STATES_OPTIONS } from 'constants/statesList';
import useDebounce from 'hooks/useDebounce';
import { useGetMarketByZip } from 'hooks/useGetMarketByZip';

interface AddressFieldsProps {
  formData: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSelect: (key: keyof any, value: any) => void;
  onToggleCoordinates: (checked: boolean) => void;
}

const AddressFields: React.FC<AddressFieldsProps> = ({
    formData, onChange, onSelect, onToggleCoordinates,
}) => {
    const debouncedZipCode = useDebounce(formData.zipCode, 1000);
    const { refetch: getMarketByZip } = useGetMarketByZip(formData.zipCode || '', { enabled: false });

    useEffect(() => {
        if (debouncedZipCode) {
            updateMarketByZipCode();
        }
    }, [debouncedZipCode]);

    const updateMarketByZipCode = async () => {
        if (formData.zipCode) {
            try {
                const marketData = await getMarketByZip();
                if (marketData.data?.msaData.correlationId) {
                    onSelect('market_id', marketData.data?.msaData.correlationId);
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    return (
        <>
            {formData.useCoordinates ? (
                <div className="d-flex mb-2">
                    <div>
                        <NSInput
                            id="latitude"
                            name="latitude"
                            type="number"
                            value={formData.latitude || ''}
                            onChange={onChange}
                            label="Latitude"
                            inputClassName="mb-2"
                        />
                    </div>
                    <div className="ml-2">
                        <NSInput
                            id="longitude"
                            name="longitude"
                            type="number"
                            value={formData.longitude || ''}
                            onChange={onChange}
                            label="Longitude"
                        />
                    </div>
                </div>
            ) : (
                <>
                    <div className="mb-2">
                        <NSInput
                            id="address"
                            name="address"
                            type="text"
                            value={formData.address}
                            onChange={onChange}
                            label="Address"
                        />
                    </div>

                    <div className="d-flex mb-2">
                        <div>
                            <NSInput
                                id="city"
                                name="city"
                                type="text"
                                value={formData.city}
                                onChange={onChange}
                                label="City"
                            />
                        </div>
                        <div className="ml-2">
                            <NSInput
                                id="county"
                                name="county"
                                type="text"
                                value={formData.county}
                                onChange={onChange}
                                label="County"
                            />
                        </div>
                        <div className="ml-2">
                            <NSSelect
                                label="State"
                                name="state"
                                options={STATES_OPTIONS}
                                value={STATES_OPTIONS.find(option => option.value === formData.state) || null}
                                onChange={(option: any) => onSelect('state', option.value)}
                                isClearable={false}
                            />
                        </div>
                        <div className="ml-2">
                            <NSInput
                                id="zipCode"
                                name="zipCode"
                                type="text"
                                value={formData.zipCode}
                                onChange={onChange}
                                label="Zip code"
                            />
                        </div>
                    </div>
                </>
            )}
            <div className="mb-2 d-flex align-items-center">
                <NSSwitch
                    id="useCoordinates"
                    name="useCoordinates"
                    checked={formData.useCoordinates}
                    onChange={e => onToggleCoordinates(e.target.checked)}
                    label="Use coordinates"
                />
            </div>
        </>
    );
};

export default AddressFields;
